import { inject } from '@angular/core';
import { Router, type CanActivateFn } from '@angular/router';
import { LoginService } from '../auth/login.service';

export const authGuard: CanActivateFn = (route, state) => {
  const _Router = inject(Router);
  const _loginService = inject(LoginService);
  let tempObj: any = route;
  const path: string = tempObj["_routerState"].url;
  // Logic to verify token here
  const token = localStorage.getItem('token');
  if(token){
    if ( _loginService.hasPermission(path)) {
      return true; 
    }else{
      let getAccess = _loginService.goToTargetPath();
      _Router.navigate([getAccess]);
      return true;
    } 
  }else {
    _Router.navigate(['/auth/login']);
    return false;
  }
};
